import axios from 'axios';

const GOOGLE_TRANSLATE_API_URL = 'https://translation.googleapis.com/language/translate/v2';
const API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

/**
 * Traduce un texto al idioma especificado utilizando Google Cloud Translation API.
 * @param {string} text - El texto a traducir.
 * @param {string} targetLanguage - El código del idioma de destino (ej: 'en', 'es', 'fr').
 * @returns {Promise<string>} - El texto traducido.
 */
export const translateText = async (text, targetLanguage) => {
  if (!text) return '';
  
  try {
    const response = await axios.post(`${GOOGLE_TRANSLATE_API_URL}?key=${API_KEY}`, {
      q: text,
      target: targetLanguage,
    });

    return response.data?.data?.translations
      ? response.data.data.translations[0].translatedText
      : text;
  } catch (error) {
    console.error('Error translating text:', error);
    return text;
  }
};
